import { X, Quote } from "lucide-react";
import { MaskedLines, Overline, Reveal, Section } from "./ui";

const negations = ["Não é agenda", "Não é CRM", "Não é ERP", "Não é planner"];

export default function NotACourse() {
  return (
    <Section tone="black">
      <div className="mx-auto max-w-3xl text-center">
        <Overline>Sem aulas. Sem enrolação.</Overline>
        <MaskedLines
          inView
          as="h2"
          className="mx-auto mt-5 font-serif text-3xl font-medium leading-[1.15] tracking-tight sm:text-4xl lg:text-5xl"
          lines={["O MOM não é um curso"]}
        />
        <Reveal delay={0.15} className="mt-8 space-y-6">
          <p className="font-dmsans text-sm leading-relaxed text-white/55 sm:text-base">
            Você não precisa assistir aulas para começar.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {negations.map((n) => (
              <span key={n} className="flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 font-dmsans text-xs font-medium uppercase tracking-[0.12em] text-white/60">
                <X className="h-3.5 w-3.5 text-mom-carmim" /> {n}
              </span>
            ))}
          </div>
          <p className="pt-4 font-serif text-2xl font-medium leading-snug text-white sm:text-3xl">
            Ele existe para responder uma pergunta:{" "}
            <em className="italic text-mom-carmim">“O que eu faço agora?”</em>
          </p>
          <p className="font-serif text-lg font-normal text-white/80 sm:text-xl">
            Você entra. Mostra a situação. Recebe a missão.{" "}
            <span className="text-mom-carmim">Executa.</span>
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.2} className="mx-auto mt-16 max-w-2xl rounded-3xl border border-white/10 bg-hc-deep p-8 sm:p-10">
        <Quote className="h-6 w-6 text-mom-carmim" />
        <p className="mt-4 font-dmsans text-[11px] font-semibold uppercase tracking-[0.24em] text-mom-carmim">
          Toda missão explica por que veio
        </p>
        <p className="mt-4 font-serif text-xl font-medium italic leading-snug text-white sm:text-2xl">
          “Sua agenda está fraca e você ainda não tentou reativação. Por isso
          esta missão vem antes de uma promoção.”
        </p>
        <p className="mt-6 border-t border-dashed border-white/10 pt-5 font-dmsans text-sm leading-relaxed text-white/55">
          O MOM não apenas manda fazer. Ele também mostra por que
          aquela ação faz sentido naquele momento. Você entende a lógica — e
          executa sabendo o motivo.
        </p>
      </Reveal>
    </Section>
  );
}
